import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { MapToolsService } from '../../../services/map-tools.service';

declare var google: any;

@Component({
  selector: 'app-tools-capas',
  templateUrl: './tools-capas.component.html',
  styleUrls: ['./tools-capas.component.scss']
})
export class ToolsCapasComponent implements OnInit {

  mostrarTodos: boolean = true;
  event: Event;

  @Output() eventClose = new EventEmitter<Event>();  
  geocercas: any;
  geocercasFiltered: any;

  constructor(
    private gtp: Gtp,
    private MapToolsService: MapToolsService
  ) { }

  ngOnInit() {
    this.listaGeocercas();
  }

  ngOnDestroy(){
    this.MapToolsService.setGeocercas(this.geocercas);
  }

  closeTab(event: Event): void {
    //console.log(event)
    this.eventClose.emit(event);
  }

  innerTab(movil?) {
  }

  setGeocercas(res){    
    this.geocercas = res.sort(this.gtp.orderGeocercas);
    this.geocercasFiltered = this.geocercas;
  }

  listaGeocercas(){
    if (this.MapToolsService.geocercas.length > 0) {
      //console.log(this.MapToolsService.geocercas)
      this.setGeocercas(this.MapToolsService.geocercas);
      return;
    }
    this.MapToolsService.getGeocercasObs().subscribe(res => {   
      this.setGeocercas(res);
    });
  }

   /**
    * Filtra las geocercas vía el input
    * @param query string del nombre de la geocerca a buscar
    */

  filterGeocercas(query) {
    let res = this.geocercas.filter(s => (
      s.des_geocerca.toLocaleLowerCase().includes(query.toLocaleLowerCase())
    ));
    this.geocercasFiltered = (query == '') ? this.geocercas.sort(this.gtp.orderGeocercas) : res.sort(this.gtp.orderGeocercas);
  }

  /**
   * Muestra / Oculta una geocerca
   */
  showHideOneGeocerca(){
    console.log('Una geocerca')
    this.MapToolsService.setGeocercas(this.geocercasFiltered);
  }

  /**
   * Muestra / Oculta todas las geocercas
   * @param state 
   */
  showHideAllGeocercas(state) {
    let newlist = [];
    this.geocercasFiltered.forEach(el => {
      //console.log(el)
      el.visible = state;
      newlist.push(el);
    });
    this.mostrarTodos = (state) ? false : true;    
    this.geocercasFiltered = newlist.sort(this.gtp.orderGeocercas);    
    this.geocercas = this.geocercasFiltered;
    this.MapToolsService.setGeocercas( this.geocercasFiltered ); 
  }

  /**
   * Envía a la ubicación de la geocerca
   */
  irAGeo(movil) {
    //console.log(movil)
    var bounds = new google.maps.LatLngBounds();
    for (var i=0; i<movil.puntos.length; i++) { bounds.extend(movil.puntos[i]); }
    var center = bounds.getCenter();
    this.MapToolsService.setCenterMapa({ latitud: center.lat(), longitud: center.lng(), zoom: 15 }); 
  }

}
